import { Loader } from './PreLoaderStyles';

const PreLoader = () => {
  return <Loader />;
};

export default PreLoader;
